// Logo URL - PNG with transparent background
export const LOGO_URL = "/datyon-logo.png";

// WhatsApp URL
export const WHATSAPP_URL = "https://wa.me/34672972514?text=Hola%2C%20he%20visto%20tu%20web%20y%20me%20interesa%20saber%20donde%20puedo%20mejorar%20resultados%20en%20mi%20negocio";

// Formspree URL
export const FORMSPREE_URL = "https://formspree.io/f/myknvawy";

// Animation Variants
export const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};
